<span class="icon-pill-{{shape()}} classic" [class.active]="active()" [class.selectable]="selectable()" [class.inverted]="inverted()" [class.compact]="compact()" [class.disabled]="disabled()" [class.removable]="removable()">
  @if(iconClasses()){
    <span class="icon">
      <i [class]="iconClasses()"></i>
    </span>
  } @else if (imgUrl()) {
    <span class="icon">
      <img [src]="imgUrl()" class="imgIcon" [alt]="icon()?.name"/>
    </span>
  }
  @if(labelTranslationScope()){
    <span class="label" *transloco="let t; scope : labelTranslationScope()">{{labelTranslationKey() ?  t(labelTranslationKey()) : labelText()}}</span>
  } @else {
    <span class="label" *transloco="let t">{{labelTranslationKey() ?  t(labelTranslationKey()) : labelText()}}</span>
  }
  @if(removable()) {
    <button type="button" aria-label="Remove" class="btn btn-dismiss py-0">
      <i class="fa-solid fa-xmark"></i>
    </button>
  }
</span>